export default class AuthService {
  static onLogged = handler => global.$(window).on('auth.logged auth.postlogged', (event, data) => handler(data))
}
